import React, { useState } from 'react';
import PropTypes from 'prop-types';

import styles from './styles.module.styl';

const CommentBox = ({ vote, submit }) => {
  const [message, setMessage] = useState({ text: '' });

  return (
    <div className={styles.feedbackMessageContainer}>
      <div className={styles.feedbackMessage}>
        <textarea
          cols="24"
          rows="2"
          value={message.text}
          placeholder={
            vote === 'positive'
              ? 'Great! How can it improve?'
              : 'Oh no! How can it improve?'
          }
          onChange={e => setMessage({ text: e.target.value })}
        />

        <button
          className="btn btn-primary btn-sm"
          onClick={() => submit(message.text)}
        >
          Done
        </button>
      </div>
    </div>
  );
};

CommentBox.propTypes = {
  vote: PropTypes.string,
  submit: PropTypes.func.isRequired
};

export default CommentBox;
